export function getQueryParameter(href,parameter) {
	let query = decodeURIComponent(href)?.split('?')[1];
    if (query !== undefined) {
    	let vars = query.split('&');
    	for (let i = 0; i < vars.length; i++) {
    		let pair = vars[i].split('=');
    		if (decodeURIComponent(pair[0]) == parameter) {
    			return decodeURIComponent(pair[1]);
    		}
    	}    	
    }
    return null;
}